import { Box, Button, styled } from "@mui/material"
import { colors } from "../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  justifyContent: "space-between",
})

export const TitleStyles = {
  marginBottom: "20px",
}

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 6,
  textAlign: "center",
})

export const BottomContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: 10,
})

export const SwitchContainer = styled(Box)({
  marginTop: 10,
  display: "flex",
  gap: 20,
  flexWrap: "nowrap",
})

export const CheckboxContainer = styled(Box)({
  marginTop: 16,
  marginBottom: 10,
  display: "flex",
  gap: 20,
  flexWrap: "nowrap",
  textAlign: "start",
  "& .MuiButtonBase-root": {
    padding: 0,
  },
  "& .MuiTypography-root": {
    textAlign: "start",
    "& a": {
      color: colors.blue,
    },
  },
})

export const ToolButton = styled(Box)({
  display: "flex",
  alignItems: "center",
})

export const StyledButton = styled(Button)({
  marginTop: 10,
  minHeight: 54,
  width: "100%",
})
